module.exports = __webpack_public_path__ + "static/university-sports-f0d655d5d0f6d248d9b74e559e4a344a.jpg";